module.exports = __webpack_public_path__ + "img/set.33ad9fc4.jpg";